import React, { useState, useEffect, useRef } from "react";
import Sidebar from '../../composant_reutilisable/sidebar';
import Navbar from "../../composant_reutilisable/navbar";
import useAuth from '../../composant_reutilisable/useAuth';
import { Link } from "react-router-dom";
import { createPortal } from "react-dom";
import { useLocation } from 'react-router-dom';
import TableauDynamique from "../../composant_reutilisable/tableau";
import { BsPeople } from "react-icons/bs";
import { Modal, Button } from "react-bootstrap"; // Ajout du modal Bootstrap
import ModalComponent from "../../composant_reutilisable/composant_modal";
import { FaCogs, FaUndo, FaQuestionCircle, FaTrash, FaExclamationTriangle, FaSortAmountDown, FaSortAmountUp, FaEllipsisV, FaEdit, FaShareAlt, FaBan, FaCheck } from "react-icons/fa";
import { useNavigate } from 'react-router-dom';
import Footer from "../../composant_reutilisable/footer";
import { BsGridFill, BsListUl } from "react-icons/bs";

const Signalements = () => {
    // useAuth();
    const navigate = useNavigate();

    // const utilisateur_id = localStorage.getItem("utilisateur_id");
    const [isLoading, setIsLoading] = useState(false);
    const [menu, setMenu] = useState(null);
    const menuRef = useRef(null);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
    const user_id = localStorage.getItem('userId');
    const [selectedSignalement, setSelectedSignalement] = useState(null);
    const [alert, setAlert] = useState({ message: '', type: '' });
    const [alertModal, setAlertModal] = useState({ message: '', type: '' });
    const [sortConfig, setSortConfig] = useState({ key: "date", direction: "descending" });
    const [filtreStatut, setFiltreStatut] = useState("tous");
    const [showDetailModal, setShowDetailModal] = useState(false);
    const [showSuspendModal, setShowSuspendModal] = useState(false);
    const [showRetirerModal, setShowRetirerModal] = useState(false);
    const [selectedSignalementDetails, setSelectedSignalementDetails] = useState(null);
    const [signalements, setSignalements] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(16);
    const [signalementSelectionne, setGroupeSelectionne] = useState(null);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [displayMode, setDisplayMode] = useState("list");



    useEffect(() => {
        if (user_id) {
            document.title = "Showtime | Liste évènements signalés";
        }
    }, [user_id]);

    // États pour gérer le modal
    const [showModal, setShowModal] = useState(false);


    const showAlert = (message, type = 'success') => {
        setAlert({ message, type });
        setTimeout(() => {
            setAlert({ message: '', type: '' });
        }, 5000);
    };

    const showAlertModal = (message, type = 'success') => {
        setAlertModal({ message, type });
        setTimeout(() => {
            setAlertModal({ message: '', type: '' });
        }, 5000);
    };

    const location = useLocation();
    const evenement_id = location.state?.evenement_id;
    const evenement_nom = location.state?.evenement_nom;
    const traitement_id = location.state?.traitement_id;
    const isTraitement = location.state?.isTraitement;

    const handleSuspendModal = () => {
        setShowSuspendModal(!showSuspendModal);
    };
    const handleRetirerModal = () => {
        setShowRetirerModal(true);
    };

    // Utilisez evenement_id dans votre fetchSignalements
    const fetchSignalements = async () => {
        try {
            setIsLoading(true);
            let url;

            if (isTraitement) {
                url = `${process.env.REACT_APP_HOTE}/signalements-par-traitement/${traitement_id}/`;
            } else {
                url = `${process.env.REACT_APP_HOTE}/liste-signalements/${evenement_id}/`;
            }

            const response = await fetch(url);

            if (!response.ok) {
                throw new Error(`Erreur serveur: ${response.status}`);
            }

            const data = await response.json();
            console.log("Signalements récupérés :", data);
            setSignalements(data);
        } catch (error) {
            console.error("Erreur lors du chargement des signalements :", error);
            showAlert("Une erreur est survenue lors du chargement des signalements", "danger");
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        if (evenement_id || traitement_id) {
            fetchSignalements();
        }
    }, [evenement_id, traitement_id]);


    // Filtrage
    const signalementsFiltres = signalements.filter(signalement =>
        signalement?.nom_evenement?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        signalement?.details?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        signalement?.raison?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        signalement?.date?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        signalement?.signale_par?.toLowerCase().includes(searchTerm.toLowerCase())
    );



    const sortedSignalements = [...signalementsFiltres].sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) return sortConfig.direction === "ascending" ? -1 : 1;
        if (a[sortConfig.key] > b[sortConfig.key]) return sortConfig.direction === "ascending" ? 1 : -1;
        return 0;
    });

    // Pagination
    const totalItems = signalementsFiltres.length;
    const totalPages = Math.ceil(totalItems / itemsPerPage);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfLastSignalement = currentPage * itemsPerPage;
    const indexOfFirstSignalement = indexOfLastSignalement - itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentSignalements = sortedSignalements.slice(indexOfFirstSignalement, indexOfLastSignalement);
    const signalementsAffiches = signalementsFiltres.slice(indexOfFirstItem, indexOfLastItem);


    // Gestion du modal
    const handleOpenModal = () => setShowModal(true);
    const handleCloseModal = () => setShowModal(false);

    // Gestion du formulaire d'ajout


    const handleClick = (event, signalement) => {
        event.stopPropagation();

        if (menu?.signalement?.id === signalement.id) {
            setMenu(null);
            return;
        }

        const buttonRect = event.currentTarget.getBoundingClientRect();

        setMenu({
            signalement,
            x: buttonRect.left + window.scrollX, // Ajoutez le défilement horizontal
            y: buttonRect.bottom + window.scrollY, // Ajoutez le défilement vertical
        });
    };

    const closeMenu = () => setMenu(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            const isActionButton = event.target.closest(".action-button");
            if (
                menuRef.current &&
                !menuRef.current.contains(event.target) &&
                !isActionButton
            ) {
                closeMenu();
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [menu]);





    const handleSort = (key) => {
        setSortConfig({
            key,
            direction: sortConfig.key === key && sortConfig.direction === "ascending" ? "descending" : "ascending"
        });
    };


    const handleShowDeleteModal = (signalementSelectionne) => {
        setGroupeSelectionne(signalementSelectionne);
        if (!signalementSelectionne) return;
        setShowDeleteModal(true);
    };

    const handleCloseDeleteModal = () => {
        setShowDeleteModal(false);
    };

    const colonnesdropdown = [
        {
            label: "Retirer",
            icon: <FaCogs color="blue" />,
            actionKey: "retirer",
        },
        {
            label: "Suspendre",
            icon: <FaTrash color="red" />,
            actionKey: "suspendre",
        },
    ];



    const menuStyle = {
        position: "absolute",
        backgroundColor: "white",
        boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
        borderRadius: "4px",
        zIndex: 1000,
        minWidth: "150px",
        border: "1px solid #ddd",
        padding: "5px 0",
        right: "auto", // S'assure qu'il n'y a pas de position right
        left: 0, // Positionné à gauche
    };

    const menuItemStyle = {
        padding: "8px 16px",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        ":hover": {
            backgroundColor: "#f5f5f5",
        },
    };




    const MenuItem = ({ icon, color, label, onClick }) => (
        <li className="context-menu-item" onClick={onClick}>
            <span className="context-menu-icon" style={{ color }}>
                {icon}
            </span>
            <span>{label}</span>
        </li>
    );

    const handleDeleteEvenement = async () => {

    };

    const handleSignalementClick = (signalement) => {
        setSelectedSignalementDetails({
            nom_evenement: signalement.nom_evenement,
            hoster: signalement.hoster,
            signale_par: signalement.signale_par,
            details: signalement.details,
            raison: signalement.raison,
            date: signalement.date,
            signalement_id: signalement.signalement_id
        });
        setShowDetailModal(true);
    };
    const [filtresActifs, setFiltresActifs] = useState(false);

    const handleStartDateChange = (e) => {
        setStartDate(e.target.value);
        setFiltresActifs(e.target.value !== "" || endDate !== "");
    };

    const handleEndDateChange = (e) => {
        setEndDate(e.target.value);
        setFiltresActifs(startDate !== "" || e.target.value !== "");
    };

    const reinitialiserFiltres = () => {
        setStartDate("");
        setEndDate("");
        setFiltresActifs(false);
    };



    const handleSuspendEvent = async () => {
        const evenement_id = location.state?.evenement_id;

        if (!user_id) {
            showAlert("Erreur : utilisateur non authentifié", "danger");
            setIsLoading(false);
            return;
        }

        if (!evenement_id) {
            showAlert("Erreur : aucun événement sélectionné", "danger");
            setIsLoading(false);
            return;
        }
        try {
            setIsLoading(true);
            console.log('URL:', `${process.env.REACT_APP_HOTE}/suspendre-evenement/${user_id}/`);
            console.log('Body:', JSON.stringify({ evenement_id }));

            const response = await fetch(`${process.env.REACT_APP_HOTE}/suspendre-evenement/${user_id}/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                },
                body: JSON.stringify({
                    evenement_id: evenement_id
                })
            });
            if (!response.ok) {
                throw new Error(`Erreur ${response.status}`);
            }

            const data = await response.json();
            if (data.success) {
                showAlert("L'événement a été suspendu avec succès", "success");
                // Redirection vers le deuxième onglet
                navigate("/Liste-evenements-signales?tab=traites");
            } else {
                showAlert(data.error || "Erreur lors de la suspension", "danger");
            }
        } catch (error) {
            console.error("Erreur:", error);
            showAlert("Une erreur est survenue", "danger");
        } finally {
            setIsLoading(false);
            setShowSuspendModal(false);
        }
    };

    const handleRestoreEvent = async () => {
        const evenement_id = location.state?.evenement_id;

        if (!user_id) {
            showAlert("Erreur : utilisateur non authentifié", "danger");
            setIsLoading(false);
            return;
        }

        if (!evenement_id) {
            showAlert("Erreur : aucun événement sélectionné", "danger");
            setIsLoading(false);
            return;
        }

        try {
            setIsLoading(true);
            console.log('URL:', `${process.env.REACT_APP_HOTE}/restaurer-evenement/${user_id}/`);
            console.log('Body:', JSON.stringify({ evenement_id }));

            const response = await fetch(`${process.env.REACT_APP_HOTE}/restaurer-evenement/${user_id}/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                },
                body: JSON.stringify({
                    evenement_id: evenement_id
                })
            });

            const data = await response.json();
            if (!response.ok) {
                throw new Error(data.error || `Erreur ${response.status}`);
            }

            if (data.success) {
                showAlert("L'événement a été restauré avec succès", "success");
                navigate("/Liste-evenements-signales"); // redirection ici
            } else {
                showAlert(data.error || "Erreur lors de la restauration", "danger");
            }
        } catch (error) {
            console.error("Erreur:", error);
            showAlert(`Une erreur est survenue : ${error.message}`, "danger");
        } finally {
            setIsLoading(false);
            setShowRetirerModal(false);
        }
    };


    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div>
                    <div className="row wrapper border-bottom white-bg page-heading">
                        <div className="col-lg-12">
                            <h2 className="d-flex justify-content-between align-items-center">
                                <div className="d-flex align-items-center">
                                    <FaExclamationTriangle size={25} className='mr-2' />Gestion des signalements
                                </div>
                            </h2>
                            {/* <small>Administration des évènements signalés.</small> */}

                            <small id='hbreadcrumb' className='d-flex justify-content-between align-items-center'>
                                <span>Gestion des signalements {isTraitement ? "du traitement" : "de"} <strong>{evenement_nom || "Non spécifié"}</strong></span>
                                <ol className="breadcrumb custom-breadcrumb">
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/Admin`}> Administration</Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item active">
                                        <Link to={`/Liste-evenements-signales`}>Evènements signalés</Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item active">
                                        Signalements
                                    </li>
                                </ol>
                            </small>
                        </div>
                    </div>

                    {alert.message && (
                        <div className={`mt-3 alert alert-${alert.type}`}>
                            {alert.message}
                        </div>
                    )}
                    <div className="wrapper wrapper-content animated fadeInRight mt-3">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <h5>Liste des signalements</h5>
                            {!isTraitement && (
    <div className="text-right align-items-center">
        <button className="btn btn-primary mr-2 py-1 d-inline-flex align-items-center" onClick={handleRetirerModal}>
            <FaUndo className="mr-1" style={{ verticalAlign: 'middle' }} /> Restaurer
        </button>
        <button
            className="btn btn-danger mr-2 py-1 d-inline-flex align-items-center"
            onClick={handleSuspendModal}
        >
            <FaBan className="mr-1" style={{ verticalAlign: 'middle' }} />
            Suspendre
        </button>
    </div>
)}
                        </div>
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="ibox">
                                    <div className="ibox-content">
                                        <div className="d-flex justify-content-between align-items-center mb-3" style={{ gap: "10px" }}>
                                            <div className="d-flex align-items-center" style={{ gap: "10px" }}>
                                                <select
                                                    id="itemsPerPage"
                                                    value={itemsPerPage}
                                                    onChange={(e) => {
                                                        setItemsPerPage(Number(e.target.value));
                                                        setCurrentPage(1);
                                                    }}
                                                    className="form-select bg-default p-1"
                                                    style={{
                                                        width: "auto",
                                                        border: "1px black solid",
                                                        borderRadius: "5px",
                                                    }}
                                                >
                                                    <option value={12}>12</option>
                                                    <option value={22}>22</option>
                                                    <option value={50}>50</option>
                                                </select>
                                                <div className="d-flex justify-content-center flex-grow-1">
                                                    <div className="d-flex " style={{ gap: "10px" }}>
                                                        <div className="d-flex align-items-center" style={{ gap: "10px" }}>
                                                            <label htmlFor="startDate" className="mb-0">Du:</label>
                                                            <input
                                                                type="date"
                                                                id="startDate"
                                                                className="form-control"
                                                                style={{ maxWidth: "150px", borderRadius: "5px" }}
                                                                value={startDate}
                                                                onChange={handleStartDateChange}
                                                            />
                                                        </div>
                                                        <div className="d-flex align-items-center" style={{ gap: "10px" }}>
                                                            <label htmlFor="endDate" className="mb-0">Au:</label>
                                                            <input
                                                                type="date"
                                                                id="endDate"
                                                                className="form-control"
                                                                style={{ maxWidth: "150px", borderRadius: "5px" }}
                                                                value={endDate}
                                                                onChange={handleEndDateChange}
                                                                min={startDate}
                                                            />
                                                        </div>
                                                        {filtresActifs && (
                                                            <button
                                                                className="btn btn-secondary py-1"
                                                                onClick={reinitialiserFiltres}
                                                            >
                                                                Réinitialiser
                                                            </button>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="d-flex align-items-center" style={{ gap: "10px" }}>
                                                <input
                                                    type="text"
                                                    placeholder="Rechercher..."
                                                    className="form-control"
                                                    style={{ width: "250px", borderRadius: "5px" }}
                                                    value={searchTerm}
                                                    onChange={(e) => setSearchTerm(e.target.value)}
                                                />

                                                <div className="btn-group">
                                                    <button
                                                        className={`btn btn-sm ${displayMode === 'list' ? 'btn-success' : 'btn-light'}`}
                                                        onClick={() => setDisplayMode('list')}
                                                        title="Vue liste"
                                                    >
                                                        <BsListUl />
                                                    </button>
                                                    <button
                                                        className={`btn btn-sm ${displayMode === 'grid' ? 'btn-success' : 'btn-light'}`}
                                                        onClick={() => setDisplayMode('grid')}
                                                        title="Vue grille"
                                                    >
                                                        <BsGridFill />
                                                    </button>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="table-responsive" style={{ overflowX: 'hidden' }}>
                                            {displayMode === "grid" ? (
                                                <div className="row">
                                                    {currentSignalements && currentSignalements.length > 0 ? (
                                                        currentSignalements.map((signalement) => (
                                                            <div className="col-md-3 mb-4" key={signalement.signalement_id}>
                                                                <div
                                                                    className={`signalement-card p-3 shadow-sm bg-white rounded border ${selectedSignalement?.signalement_id === signalement.signalement_id ? "border-primary" : "border-light"}`}
                                                                    onClick={() => handleSignalementClick(signalement)}
                                                                    style={{ cursor: 'pointer', transition: '0.3s ease' }}
                                                                >
                                                                    <h5 className="mb-2 text-primary font-weight-bold">{signalement.signale_par}</h5>
                                                                    <div className="d-flex justify-content-between align-items-center">
                                                                        <div>
                                                                            <span className="text-muted small">Contact :</span><br />
                                                                            <span className="font-weight-semibold">{signalement.contact}</span>
                                                                        </div>
                                                                        <div className="text-right">
                                                                            <span className="text-muted small">Signalé le</span><br />
                                                                            <span className="text-dark small">{new Date(signalement.date).toLocaleDateString()}</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))
                                                    ) : (
                                                        <div className="col-12 text-center py-4">
                                                            <span className="text-muted">Aucun signalement trouvé</span>
                                                        </div>
                                                    )}
                                                </div>
                                            ) : (
                                                <table className="footable table table-stripped footable-loaded tablet breakpoint"
                                                    data-page-size="8" data-filter="#filter" style={{ fontSize: "12px" }}>
                                                    <thead>
                                                        <tr>
                                                            <th className="text-secondary text-wrap d-none d-md-table-cell"
                                                                onClick={() => handleSort("date")}
                                                                style={{ width: "30%", minWidth: "100px" }}>
                                                                Date signalement {sortConfig.key === "date"} {sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                            </th>
                                                            <th className="text-secondary text-wrap d-none d-md-table-cell"
                                                                onClick={() => handleSort("signale_par")}
                                                                style={{ width: "30%", minWidth: "100px" }}>
                                                                Signaleur {sortConfig.key === "signale_par"}
                                                                {sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                            </th>
                                                            <th className="text-secondary text-wrap d-none d-md-table-cell align-middle"
                                                                onClick={() => handleSort("raison")}
                                                                style={{ width: "30%", minWidth: "100px" }}>
                                                                Raison {sortConfig.key === "raison"}
                                                                {sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                            </th>
                                                            <th className="text-secondary text-wrap d-none d-md-table-cell"
                                                                onClick={() => handleSort("date")}
                                                                style={{ width: "30%", minWidth: "100px" }}>
                                                                Contact {sortConfig.key === "date"}
                                                                {sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {currentSignalements && currentSignalements.length > 0 ? (
                                                            currentSignalements.map((signalement) => (
                                                                <tr key={signalement.signalement_id}
                                                                    onClick={() => handleSignalementClick(signalement)}
                                                                    style={{ cursor: 'pointer' }}>
                                                                    <td className="d-none d-md-table-cell align-middle" style={{ padding: "0.5rem" }}>
                                                                        <span>{new Date(signalement.date).toLocaleDateString()}</span>
                                                                    </td>
                                                                    <td className="d-none d-md-table-cell align-middle" style={{ padding: "0.5rem" }}>
                                                                        <span>{signalement.signale_par}</span>
                                                                    </td>
                                                                    <td className="d-none d-md-table-cell align-middle" style={{ padding: "0.5rem" }}>
                                                                        <span className="fw-semibold">{signalement.raison}</span>
                                                                    </td>
                                                                    <td className="d-none d-md-table-cell align-middle" style={{ padding: "0.5rem" }}>
                                                                        <span>{signalement.contact}</span>
                                                                    </td>
                                                                </tr>
                                                            ))
                                                        ) : (
                                                            <tr>
                                                                <td colSpan="3" className="text-center">
                                                                    Aucun signalement trouvé
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                            )}
                                        </div>

                                        {/* Pagination Controls (garder le même code) */}
                                        <div className="d-flex justify-content-between align-items-center mt-3">
                                            <div className="dataTables_info" role="status" aria-live="polite">
                                                {totalItems === 0
                                                    ? "Aucun élément à afficher"
                                                    : `Élément ${currentPage === 1
                                                        ? 1
                                                        : (currentPage - 1) * itemsPerPage + 1
                                                    } à ${currentPage * itemsPerPage > totalItems
                                                        ? totalItems
                                                        : currentPage * itemsPerPage
                                                    } sur ${totalItems}`}
                                            </div>
                                            <div>
                                                {Array.from({ length: totalPages }, (_, index) => (
                                                    <button
                                                        key={index + 1}
                                                        onClick={() => setCurrentPage(index + 1)}
                                                        className={`btn ${currentPage === index + 1
                                                            ? "btn-default"
                                                            : "btn-light"
                                                            } mx-1`}
                                                    >
                                                        {index + 1}
                                                    </button>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="footer text-center">
                        <Footer />
                    </div>
                </div>
            </div>



            <Modal
                show={showDetailModal}
                onHide={() => setShowDetailModal(false)}
                centered
            >
                <Modal.Header className="border-1 rounded-top">
                    <Modal.Title className="font-bold">Examiner le signalement</Modal.Title>
                </Modal.Header>
                <Modal.Body className="pt-3">
                    <div className="mb-4 p-3 bg-light rounded">
                        <div className="item d-flex justify-content-between mb-2">
                            <span className="item-label font-weight-bold">Nom évènement :</span>
                            <span className="item-value">{selectedSignalementDetails?.nom_evenement || "Non spécifié"}</span>
                        </div>
                        <div className="item d-flex justify-content-between mb-2">
                            <span className="item-label font-weight-bold">Hoster :</span>
                            <span className="item-value">{selectedSignalementDetails?.hoster || "Non spécifié"}</span>
                        </div>
                        <div className="item d-flex justify-content-between mb-2">
                            <span className="item-label font-weight-bold">Date du signalement :</span>
                            <span className="item-value">{new Date(selectedSignalementDetails?.date).toLocaleDateString() || "Non spécifié"}</span>
                        </div>
                        <div className="item d-flex justify-content-between mb-2">
                            <span className="item-label font-weight-bold">Signaleur :</span>
                            <span className="item-value">{selectedSignalementDetails?.signale_par || "Non spécifié"}</span>
                        </div>
                        <div className="item d-flex justify-content-between mb-2">
                            <span className="item-label font-weight-bold">Raison :</span>
                            <span className="item-value">{selectedSignalementDetails?.raison || "Non spécifié"}</span>
                        </div>
                    </div>

                    <div className="form-group mt-4">
                        <label className="h5 mb-3">Motif de signalement:</label>
                        <div className="p-3 bg-light rounded" style={{ minHeight: '150px' }}>
                            {selectedSignalementDetails?.details || "Non spécifié"}
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer className="border-top-0  justify-content-center" style={{ marginTop: "-20px" }}>
                    <button className="btn btn-secondary" onClick={() => setShowDetailModal(false)}>
                        Fermer
                    </button>
                </Modal.Footer>
            </Modal>

            {/* Modal de confirmation de retrait */}
            <Modal show={showRetirerModal} onHide={() => setShowRetirerModal(false)} centered size="sm" style={{ fontSize: "11px" }}>
                <Modal.Body className="text-center">
                    <FaUndo className="text-restaure mb-3" size={60} style={{ marginTop: "-15px" }} />
                    <p>Êtes-vous sûr de vouloir restaurer cet évènement ?</p>
                </Modal.Body>

                <Modal.Footer className="border-top-0 flex-column align-items-center" style={{ marginTop: "-40px" }}>
                    <div className="d-flex justify-content-center mb-2">
                        <Button variant="secondary" className="mr-5 px-4" onClick={() => setShowRetirerModal(false)}>
                            Non
                        </Button>
                        <Button variant="primary" className="px-4" onClick={() => {
                            handleRestoreEvent();
                            setShowRetirerModal(false);
                            showAlert("L'événement a été retiré avec succès", "success");
                        }}>
                            Oui
                        </Button>
                    </div>
                    <small className="text-muted text-center mb-3">
                        Cet événement sera remis en fil d'actualité.
                    </small>
                </Modal.Footer>
            </Modal>


            {/* Modal de confirmation de suspension */}
            <Modal show={showSuspendModal} onHide={() => setShowSuspendModal(false)} centered size="sm" style={{ fontSize: "11px" }}>
                <Modal.Body className="text-center">
                    <FaBan className="text-danger mb-3" size={60} style={{ marginTop: "-15px" }} />
                    <p>Êtes-vous sûr de vouloir suspendre cet évènement ?</p>
                </Modal.Body>

                <Modal.Footer className="border-top-0 flex-column align-items-center" style={{ marginTop: "-40px" }}>
                    <div className="d-flex justify-content-center mb-2">
                        <Button variant="secondary" className="mr-5 px-4" onClick={() => setShowSuspendModal(false)}>
                            Non
                        </Button>
                        <Button variant="danger" className="px-4" onClick={() => {
                            handleSuspendEvent();
                            setShowSuspendModal(false);
                            showAlert("L'événement a été suspendu avec succès", "success");
                        }}>
                            Oui
                        </Button>
                    </div>
                    <small className="text-muted text-center mb-3">
                        Cette action est irréversible et empêchera tout accès à l’événement.
                    </small>
                </Modal.Footer>
            </Modal>






        </div>
    );
};

export default Signalements;
